import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AutomationService } from 'src/app/shared/services/automation.service';

@Component({
  selector: 'app-upload-lcd-policy-doc-modal',
  templateUrl: './upload-lcd-policy-doc-modal.component.html',
  styleUrls: ['./upload-lcd-policy-doc-modal.component.scss'],
})
export class UploadLcdPolicyDocModalComponent implements OnInit {
  fileName: string = '';
  selectedPayer: string = '';
  selectedFile: File | null = null;
  isSubmitting: boolean = false;
  isProcessing: boolean = false;
  description: string = '';

  payers: string[] = [
    'Health Net',
    'Humana',
    'Medicare',
    'Worksman Comp.',
    'Great West',
    'UHC',
    'Aetna',
    'Cigna',
    'Blue Cross Blue Shield',
    'Blue Shield of California',
    'Sante',
    'Anthem',
    'Physician Mutual Insurance',
    'State Farm',
    'Mutual of Omaha Insurance Company',
    'Adventist Health',
    'Alignment Health Plan',
    'Tricare',
  ];

  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(
    public activeModal: NgbActiveModal,
    private spinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private automationService: AutomationService
  ) {}

  ngOnInit(): void {}

  onFileSelected(event: any): void {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    if (file.type !== 'application/pdf') {
      this.toastr.error('Please select a PDF file');
      this.selectedFile = null;
      return;
    }
    this.selectedFile = file;
  }

  removeFile(): void {
    this.selectedFile = null;
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  browseFiles(): void {
    this.fileInput.nativeElement.click();
  }

  async submit(): Promise<void> {
    if (!this.fileName.trim()) {
      this.toastr.error('Please enter a file name');
      return;
    }
    if (!this.selectedPayer) {
      this.toastr.error('Please select a payer');
      return;
    }
    if (!this.selectedFile) {
      this.toastr.error('Please select a PDF file');
      return;
    }

    this.isSubmitting = true;
    this.spinnerService.show();
    try {
      const res = await this.automationService.uploadLcdPolicyDocument(
        this.fileName.trim(),
        this.selectedPayer,
        this.description,
        this.selectedFile
      );
      this.spinnerService.hide();
      this.isSubmitting = false;
      
      if (res && res.code === 200) {
        this.toastr.success('LCD Policy Document uploaded successfully!');
        this.activeModal.close(res);
      } else {
        this.toastr.error(res?.message || 'Failed to upload LCD policy document');
      }
    } catch (err: any) {
      this.spinnerService.hide();
      this.isSubmitting = false;
      console.error(err);
      this.toastr.error(err?.error?.message || err?.message || 'Failed to upload LCD policy document');
    }
  }
}
